import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SessionExpiredService {
  private readonly isOpenSubject = new BehaviorSubject<boolean>(false);
  public isOpen$: Observable<boolean> = this.isOpenSubject.asObservable();

  /**
   * Show the session expired modal
   */
  show(): void {
    this.isOpenSubject.next(true);
  }

  /**
   * Hide the session expired modal
   */
  hide(): void {
    this.isOpenSubject.next(false);
  }

  /**
   * Get current state
   */
  get isOpen(): boolean {
    return this.isOpenSubject.value;
  }
}








